import { isEmpty } from 'lodash';
import { GetMarksListResponse } from '.';

export const structureAssessmentData = (
  assessmentData: GetMarksListResponse[]
) => {
  return assessmentData.map((assessment: GetMarksListResponse) => {
    const assessmentDetails = {
      id: JSON.stringify({
        examId: assessment.exam.id,
        subjectId: assessment.subject.id
      }),
      grade: assessment.exam.grade,
      division: assessment.exam.division,
      term: assessment.term,
      exam: assessment.exam.name,
      weightage: assessment.exam.weightage + '%',
      subject: assessment.subject.name,
      scoringType: assessment.subject.scoringType,
      maxMarks: assessment.subject.maxMarks,
      totalStudents: assessment.totalStudents,
      studentMarksEntered: isEmpty(
        assessment.totalStudentMarksEntered?.toString()
      )
        ? 0
        : assessment.totalStudentMarksEntered,
      percentage: isEmpty(assessment.studentMarksEnteredPercentage?.toString())
        ? '-'
        : assessment.studentMarksEnteredPercentage + '%',
      enableEvaluation: !assessment.subject.disableEvaluation
    };
    return assessmentDetails;
  });
};
